/*
 * Request a Sample — modal behaviour + Klaviyo client-side capture.
 * Paired with snippets/request-a-sample.liquid.
 *
 * Modal: a theme-style overlay (NOT a native top-layer <dialog>) so the Google
 * Places autocomplete dropdown can paint above it.
 *
 * On submit:
 *   - ALWAYS POST /client/events  ("Requested Sample" + profile with location).
 *     The confirmation is gated on THIS call (it carries the lead + triggers the
 *     owner-alert flow). Retries once on a 5xx.
 *   - IF marketing consent checked: POST /client/subscriptions (atelier__members),
 *     best-effort (also retried once on 5xx); a subscription hiccup does not block
 *     the confirmation since the lead is already captured by the event.
 * Klaviyo public company id + list id are not secrets (public client API).
 * Owner email is handled by a Klaviyo flow (Internal Alert on the metric).
 */
(function () {
  if (window.__lunburgRAS) return;
  window.__lunburgRAS = true;

  var KLAVIYO_COMPANY_ID = 'TJ3xFH';
  var KLAVIYO_LIST_ID = 'TceZsQ'; // atelier__members
  var KLAVIYO_REVISION = '2026-04-15';
  var EVENT_NAME = 'Requested Sample';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var modal = document.querySelector('[data-ras-dialog]');
    if (!modal) return;

    // Make the modal a true top-level overlay. In its authored DOM position
    // (inside the sticky product-info column: <safe-sticky class="product-info">,
    // which is position:sticky; z-index:2) it is confined to that column's stacking
    // context and paints BENEATH the sticky header (z-index:4) and the sticky ATC
    // bar, regardless of its own z-index. Relocating it to <body> makes it a
    // root-level overlay above all page chrome. Variant switches on this template
    // are full navigations (not in-page rerenders), so the modal is never recreated;
    // the open/close triggers live outside the modal and keep working via closure.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    var panel = modal.querySelector('.ras-modal__panel') || modal;
    var form = modal.querySelector('[data-ras-form]');
    var formWrap = modal.querySelector('[data-ras-form-wrap]');
    var success = modal.querySelector('[data-ras-success]');
    var errorEl = modal.querySelector('[data-ras-error]');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var mapsKey = modal.getAttribute('data-ras-maps-key') || '';
    var productTitle = modal.getAttribute('data-ras-product') || '';
    var lastFocus = null;
    var prevOverflow = '';
    var placesRequested = false;

    function fld(name) { return form.querySelector('[name="' + name + '"]'); }
    function val(name) { var f = fld(name); return f ? (f.value || '').trim() : ''; }
    function isOpen() { return !modal.hasAttribute('hidden'); }

    /* ---- Open / close (overlay, not native dialog) ---- */
    function openModal(e) {
      if (e) e.preventDefault();
      if (isOpen()) return;
      lastFocus = document.activeElement;
      if (success) success.hidden = true;
      if (formWrap) formWrap.hidden = false;
      if (errorEl) errorEl.hidden = true;
      modal.removeAttribute('hidden');
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('ras-modal-open');
      document.addEventListener('keydown', onKeydown);
      var first = form.querySelector('input:not([type="hidden"]), select, textarea');
      if (first) { try { first.focus(); } catch (e2) {} }
      loadPlaces();
    }

    function closeModal() {
      if (!isOpen()) return;
      modal.setAttribute('hidden', '');
      document.documentElement.style.overflow = prevOverflow;
      document.documentElement.classList.remove('ras-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key === 'Tab') { trapTab(e); }
    }

    function trapTab(e) {
      var sel = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var list = Array.prototype.filter.call(panel.querySelectorAll(sel), function (el) { return el.offsetParent !== null; });
      if (!list.length) return;
      var firstEl = list[0], lastEl = list[list.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }

    document.querySelectorAll('[data-ras-open]').forEach(function (o) { o.addEventListener('click', openModal); });
    modal.querySelectorAll('[data-ras-close]').forEach(function (b) { b.addEventListener('click', closeModal); });

    /* ---- Google Places (lazy) ---- */
    function loadPlaces() {
      if (window.google && window.google.maps && window.google.maps.places) { initAutocomplete(); return; }
      if (placesRequested || !mapsKey) return;
      placesRequested = true;
      window.__rasInitPlaces = function () { initAutocomplete(); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(mapsKey) +
              '&libraries=places&loading=async&callback=__rasInitPlaces';
      s.async = true; s.defer = true;
      s.onerror = function () { /* manual entry still works */ };
      document.head.appendChild(s);
    }

    function initAutocomplete() {
      try {
        if (!(window.google && google.maps && google.maps.places)) return;
        var a1 = fld('address1');
        if (!a1 || a1.dataset.rasAc === '1') return;
        a1.dataset.rasAc = '1';
        var ac = new google.maps.places.Autocomplete(a1, { types: ['address'], fields: ['address_components'] });
        ac.addListener('place_changed', function () {
          var place = ac.getPlace();
          if (place && place.address_components) fillFromPlace(place.address_components);
        });
      } catch (err) { /* ignore */ }
    }

    function comp(components, type) {
      for (var i = 0; i < components.length; i++) {
        if (components[i].types.indexOf(type) > -1) return components[i].long_name;
      }
      return '';
    }
    function setVal(name, v) { var f = fld(name); if (f && v) f.value = v; }
    function fillFromPlace(c) {
      var streetNo = comp(c, 'street_number');
      var route = comp(c, 'route');
      setVal('address1', (streetNo ? streetNo + ' ' : '') + route);
      setVal('city', comp(c, 'locality') || comp(c, 'postal_town') || comp(c, 'sublocality'));
      setVal('region', comp(c, 'administrative_area_level_1'));
      setVal('zip', comp(c, 'postal_code'));
      setVal('country', comp(c, 'country'));
      var z = fld('zip'); if (z && !z.value) { try { z.focus(); } catch (e) {} }
    }

    /* ---- Selected variant / options (best effort) ---- */
    function getContext() {
      var ctx = { variant_id: '', options: '' };
      try {
        var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (idInput) ctx.variant_id = idInput.value;
        var opts = [];
        document.querySelectorAll('form[action*="/cart/add"] input:checked').forEach(function (i) {
          if (!i.name || i.name.indexOf('options') === -1) return;
          var lab = i.closest('label') || document.querySelector('label[for="' + i.id + '"]');
          var t = ((lab && lab.textContent) || i.value || '').trim();
          if (t) opts.push(t);
        });
        ctx.options = opts.join(' / ');
      } catch (e) {}
      return ctx;
    }

    /* ---- Klaviyo client API (one retry on 5xx / network error) ---- */
    function klaviyo(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
        body: JSON.stringify(body)
      });
    }
    function klaviyoRetry(path, body) {
      return klaviyo(path, body).then(function (r) {
        if (r && r.status >= 500) { return klaviyo(path, body); }
        return r;
      }).catch(function () { return klaviyo(path, body); });
    }
    function ok2xx(r) { return r && r.status >= 200 && r.status < 300; }

    function showSuccess() { if (formWrap) formWrap.hidden = true; if (success) success.hidden = false; }
    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
      if (submitBtn) submitBtn.disabled = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;

      // Honeypot: silently treat bots as "done".
      if (val('company_website')) { showSuccess(); return; }

      if (!form.checkValidity()) { form.reportValidity(); return; }

      if (submitBtn) submitBtn.disabled = true;

      var email = val('email');
      var location = {
        address1: val('address1'), address2: val('address2'),
        city: val('city'), region: val('region'),
        zip: val('zip'), country: val('country')
      };
      var ctx = getContext();
      var consent = !!(fld('marketing_consent') && fld('marketing_consent').checked);

      var eventBody = { data: { type: 'event', attributes: {
        properties: {
          product: productTitle,
          variant_id: ctx.variant_id,
          options: ctx.options,
          address1: location.address1, address2: location.address2,
          city: location.city, region: location.region, zip: location.zip, country: location.country
        },
        metric: { data: { type: 'metric', attributes: { name: EVENT_NAME } } },
        profile: { data: { type: 'profile', attributes: {
          email: email, first_name: val('first_name'), last_name: val('last_name'), location: location
        } } }
      } } };

      // Best-effort subscription (consent-gated); runs in parallel, does not block UX.
      if (consent) {
        klaviyoRetry('subscriptions', { data: { type: 'subscription', attributes: {
          custom_source: 'Request a Sample form',
          profile: { data: { type: 'profile', attributes: {
            email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } } })
          .then(function (r) { if (!ok2xx(r)) { try { console.warn('RAS: subscription not accepted', r && r.status); } catch (e) {} } });
      }

      // Confirmation is gated on the event (the lead + owner-alert trigger).
      klaviyoRetry('events', eventBody).then(function (r) {
        if (ok2xx(r)) { showSuccess(); }
        else { showError(); }
      }).catch(function () { showError(); });
    });
  });
})();
